module.exports = __webpack_public_path__ + "static/media/svg3.6eb5bc86.svg";